module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_36.f6eeaf8f.png";